if (!customElements.get('section-cart-drawer')) {
  class TG_SectionCartDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.element = this;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.documentDelegate = new themegoal.libs.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];

      this.showCrossSell = this.options['showCrossSell'];
      this.firstItemProductId = this.options['firstItemProductId'];
      this.preFirstItemProductId = '0';
      this.actionBusy = false;
      this.returnFocusElement = null;

      this.onDrawerOpening = this._onDrawerOpening.bind(this);
      this.onDrawerOpened = this._onDrawerOpened.bind(this);
      this.onDrawerClosed = this._onDrawerClosed.bind(this);
      this.onDrawerKeydown = this._onDrawerKeydown.bind(this);
      this.onProductAdded = this._onProductAdded.bind(this);
  
      this.sidebarDrawer = new themegoal.components.Drawer(this);
      this.element.addEventListener('show.tg.Drawer', this.onDrawerOpening);
      this.element.addEventListener('shown.tg.Drawer', this.onDrawerOpened);
      this.element.addEventListener('hidden.tg.Drawer', this.onDrawerClosed);
      this.element.addEventListener('keydown', this.onDrawerKeydown);
  
      this._bindEventsListeners();
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      if(this.documentDelegate)this.documentDelegate.destroy();
      document.removeEventListener('product:added', this.onProductAdded);
      this.element.removeEventListener('show.tg.Drawer', this.onDrawerOpening);
      this.element.removeEventListener('shown.tg.Drawer', this.onDrawerOpened);
      this.element.removeEventListener('hidden.tg.Drawer', this.onDrawerClosed);
      this.element.removeEventListener('keydown', this.onDrawerKeydown);
      if(this.sidebarDrawer)this.sidebarDrawer.hide();
    }
  
    _bindEventsListeners() {
      this.delegateElement.on('change', '#CartNote', this._updateCartNote.bind(this));
      this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
      this.delegateElement.on('change', '.CartItem__QuantityNum', this._updateItemQuantity.bind(this));
      this.delegateElement.on('click', '[data-cart-clear-all]', this._openClearAllDialog.bind(this));
      this.delegateElement.on('click', '[data-cart-clear-cancel]', this._closeClearAllDialog.bind(this));
      this.delegateElement.on('click', '[data-cart-clear-confirm]', this._clearAll.bind(this));
  
      document.addEventListener('product:added', this.onProductAdded);
  
      this.documentDelegate.on('cart:refresh', this._onCartRefresh.bind(this));
    }

    _loadRecommendationsComplementary() {
      var _this = this;

      if(this.itemCount < 1){
        this.element.querySelector('.CartDrawerCrossSell').style.display = 'none';
        this.firstItemProductId = '0'
        this.preFirstItemProductId = '0'
      };
  
      if (this.firstItemProductId=='0' || _this.preFirstItemProductId == _this.firstItemProductId) return;

      var url = window.routes.productRecommendationsUrl + '?section_id=cart-drawer-cross-sell&intent=complementary&product_id=' + this.firstItemProductId + '&limit=' + this.options['recommendationsComplementaryCount'];
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;

          let recommendationsElement = _this.element.querySelector('.CartDrawerCrossSell .CartDrawerCrossSell__Body');
          let cartDrawerCrossSellHiddenFromsrecommendationsElement = _this.element.querySelector('.CartDrawerCrossSellHiddenFroms');

          if(container.querySelector('.Carousel__Item')){
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".CartDrawerCrossSell__Body").innerHTML;
            cartDrawerCrossSellHiddenFromsrecommendationsElement.innerHTML = container.querySelector(".CartDrawerCrossSellHiddenFroms").innerHTML;
            new themegoal.components.Carousel(recommendationsElement.querySelector('[data-carousel-config]'));
            _this.element.querySelector('.CartDrawerCrossSell').style.display = 'block';
          }else{
            _this.element.querySelector('.CartDrawerCrossSell').style.display = 'none';
          }

          _this.preFirstItemProductId = _this.firstItemProductId;
  
        });
      });
    }
  
    _beginCartAction(button, loadingText, scope) {
      if (this.actionBusy) return null;
      this.actionBusy = true;

      if (window.RPCartLoading) {
        return {
          uxState: button
            ? window.RPCartLoading.beginButton(button, loadingText, scope, this.element)
            : window.RPCartLoading.beginScope(scope, this.element)
        };
      }

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      if (button) button.disabled = true;
      return { button: button };
    }

    _endCartAction(actionState) {
      this.actionBusy = false;
      if (!actionState) return;
      if (actionState.uxState && window.RPCartLoading) {
        window.RPCartLoading.end(actionState.uxState);
      } else {
        if (actionState.button) actionState.button.disabled = false;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    }

    _openClearAllDialog(event, target) {
      event.preventDefault();
      var dialog = this.element.querySelector('[data-cart-clear-dialog]');

      if (!dialog || typeof dialog.showModal !== 'function') {
        if (window.confirm('Remove every product and sample from your cart?')) {
          this._clearAll(null, target);
        }
        return;
      }

      dialog.showModal();
      var cancelButton = dialog.querySelector('[data-cart-clear-cancel]');
      if (cancelButton) cancelButton.focus();
    }

    _closeClearAllDialog(event, target) {
      event.preventDefault();
      var dialog = target.closest('[data-cart-clear-dialog]');
      if (dialog && dialog.open) dialog.close();
    }

    _clearAll(event, target) {
      var _this = this;
      if (event) event.preventDefault();
      target = target || (event && event.target && event.target.closest('[data-cart-clear-confirm]'));
      var actionState = this._beginCartAction(target, 'Removing…', null);
      if (!actionState) return;
      // Empties the whole cart — tiles AND the sample box (which holds the samples
      // as properties), so one click clears everything.
      fetch(window.routes.cartUrl + '/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to clear cart');
        _this.itemCount = 0;
        document.querySelectorAll('.CartCountBubble__Count').forEach(function (el) { el.textContent = '0'; });
        return _this._rerenderCart();
      }).catch(function (error) {
        console.error('Cart clear failed:', error);
      }).finally(function () {
        _this._endCartAction(actionState);
      });
    }

    _updateCartNote(event, target) {
      fetch(window.routes.cartUrl + '/update.js', {
        body: JSON.stringify({ note: target.value }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      });
    }
  
    _updateItemQuantity(event, target) {
      var _this = this;
      event.preventDefault();
  
      var quantity = null,
          elementToAnimate = null;
  
      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        //+ - button
        quantity = parseInt(target.getAttribute('data-quantity'));
      }

      var loadingScope = target.closest('.CartTile') || target.closest('.CartItem__Wrapper') || target.parentNode;
      var actionState = this._beginCartAction(null, null, loadingScope);
      if (!actionState) return;
  
      if (quantity === 0) {
        elementToAnimate = loadingScope;
      }
  
      fetch(window.routes.cartChangeUrl + '.js', {
        body: JSON.stringify({ id: target.getAttribute('data-line-id'), quantity: quantity }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to update cart item');
        return response.json();
      }).then(function (content) {
        _this.itemCount = content['item_count'];
        return _this._rerenderCart(elementToAnimate);
      }).catch(function (error) {
        console.error('Cart item update failed:', error);
      }).finally(function () {
        _this._endCartAction(actionState);
      });
    }
  
    _onProductAdded(event) {
      var _this = this;
      var onComplete = event.detail && event.detail.onComplete;

      this._rememberReturnFocus(document.activeElement);
  
      this.itemCount += event.detail.quantity;
  
      this._rerenderCart().then(function () {
        _this.sidebarDrawer.show(_this.returnFocusElement);
      }).catch(function (error) {
        console.error('Cart drawer refresh failed:', error);
      }).finally(function () {
        if (typeof onComplete === 'function') onComplete();
      });
    }

    _rememberReturnFocus(candidate) {
      if (!candidate || candidate === document.body || this.element.contains(candidate)) return;
      this.returnFocusElement = candidate;
    }

    _onDrawerOpening(event) {
      this._rememberReturnFocus(event.relatedTarget || document.activeElement);
    }

    _onDrawerOpened() {
      var closeButton = this.element.querySelector('.ButtonClose');
      var firstFocusableElement = closeButton || this._getFocusableElements()[0];

      if (firstFocusableElement) firstFocusableElement.focus({ preventScroll: true });
    }

    _getFocusableElements() {
      var selector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ].join(',');

      return Array.prototype.slice.call(this.element.querySelectorAll(selector)).filter(function (element) {
        return element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== 'hidden';
      });
    }

    _onDrawerKeydown(event) {
      if (event.key !== 'Tab' || !this.element.classList.contains('Show')) return;

      var focusableElements = this._getFocusableElements();
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];
      var activeElement = document.activeElement;

      if (!this.element.contains(activeElement)) {
        event.preventDefault();
        firstElement.focus();
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    _onCartRefresh(event) {
      var onComplete = event && event.detail && event.detail.onComplete;
      return this._rerenderCart().catch(function (error) {
        console.error('Cart drawer refresh failed:', error);
      }).finally(function () {
        if (typeof onComplete === 'function') onComplete();
      });
    }
  
    _onDrawerClosed() {
      let cartDrawerNoteElement = document.getElementById('CartDrawerNoteCollapse');
      if(cartDrawerNoteElement){
        let cartDrawerNoteCollapse = new themegoal.components.Collapse(cartDrawerNoteElement, { toggle: false });
        cartDrawerNoteCollapse.hide();
      }

      if (this.returnFocusElement && this.returnFocusElement.isConnected) {
        this.returnFocusElement.focus({ preventScroll: true });
      }

      this.returnFocusElement = null;
    }
  
    _rerenderCart(elementToAnimate) {
      var _this = this;
  
      return fetch(window.routes.cartUrl + '?section_id=' + this.options['sectionId'] + '&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        if (!content.ok) throw new Error('Unable to refresh cart drawer');
        return content.text();
      }).then(function (html) {
        if ( elementToAnimate ) {
          return new Promise(function (resolve) {
            themegoal.libs.anime({
              targets: elementToAnimate,
              opacity: 0,
              height: 0,
              duration: 500,
              easing: 'easeOutCubic',
              complete: function() {
                _this._replaceContent(html);
                resolve();
              }
            });
          });
        } else {
          _this._replaceContent(html);
        }
      });
    }
  
    _replaceContent(html) {
      let _this = this;
  
      let tempElement = document.createElement('div');
      tempElement.innerHTML = html;
  
      let cartNodeParent = this.element.querySelector('.Form--cart').parentNode;
      let cartDrawerItemsParent = this.element.querySelector('.CartDrawer__Items').parentNode;
      let cartFooterParent = this.element.querySelector('.Drawer__Footer').parentNode;
  
      let currentScrollPosition = this.element.querySelector('.Drawer__Body').scrollTop;

      cartDrawerItemsParent.replaceChild(tempElement.querySelector('.CartDrawer__Items'), this.element.querySelector('.CartDrawer__Items'));
      cartFooterParent.replaceChild(tempElement.querySelector('.Drawer__Footer'), this.element.querySelector('.Drawer__Footer'));

      this.element.querySelector('.Drawer__Body').scrollTop = currentScrollPosition;
  
      let cartResult = JSON.parse(tempElement.querySelector('.CartDrawer').getAttribute('data-section-settings'));
  
      let cartCount = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble')),
      cartText = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountText')),
      cartQuantity = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble__Count'));
  
      this.itemCount = cartResult['itemCount'];
      this.firstItemProductId = cartResult['firstItemProductId'];
  
      cartCount.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.remove('Visible'); 
        } else {
          item.classList.add('Visible');
        }
      });
  
      cartText.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.add('Visible'); 
        } else {
          item.classList.remove('Visible');
        }
      });
  
      cartQuantity.forEach(function (item) {
        item.textContent = _this.itemCount;
        // Keep the screen-reader count (VisuallyHidden sibling) in step too — it was
        // only rendered server-side once, so it otherwise announces a stale count.
        var hidden = item.parentElement.querySelector('span.VisuallyHidden');
        if (hidden) hidden.textContent = _this.itemCount + (_this.itemCount === 1 ? ' item' : ' items');
      });


      if(this.options["freeShippingThreshold"]){
        let freeShippingElement = cartNodeParent.querySelector(".CartDrawer__ShippingAmountNotice");
        
  
        if(freeShippingElement){
          let cartTotalPrice = freeShippingElement.getAttribute("data-cart-total-price");
          let cartCurrencySymbol = freeShippingElement.getAttribute("data-cart-currency-symbol");
  
          cartTotalPrice = parseInt(cartTotalPrice);
  
          let freeShippingAmount = Math.round(this.options["freeShippingAmount"] * (Shopify.currency.rate || 1));
  
          if(cartTotalPrice >= freeShippingAmount){
            freeShippingElement.innerHTML = this.options["freeShippingString"];
          }else{
            let freeShippingAmountString = this.options["freeShippingAmountString"];
            freeShippingAmountString = freeShippingAmountString.replace("remaining__amount", "" + cartCurrencySymbol + (freeShippingAmount - cartTotalPrice)/100);
            freeShippingElement.innerHTML = freeShippingAmountString;
          }
        }
      }

      if (this.showCrossSell) {
        this._loadRecommendationsComplementary();
      }
    
    }
        
  }
        
  customElements.define('section-cart-drawer', TG_SectionCartDrawer);
}
